<template>
    <v-container class="national-races pa-0">
        <!-- Election Totals -->
        <totals
            small
            description="Our technology, from DemocraticAds.com to Deploy, empowered campaigns up and down the ballot to reach and engage voters with precision and impact in 2024."
            :totals="raceCounts">
        </totals>
        <!-- Narrative Totals -->
        <totals
            is-clickable
            description="DSPolitical championed a diverse slate of candidates and causes across the ballot in 2024. We’re honored to have uplifted underrepresented communities and energized voters nationwide to make their voices heard."
            :totals="narrativeCounts">
        </totals>
        <!-- Tech Totals -->
        <totals
            colors="primary"
            description="All of these incredible campaigns were powered by our award-winning technology. Here's just a snapshot of what we accomplished this cycle."
            :totals="totalCounts">
        </totals>
    </v-container>
</template>

<script>
    import { narrativeStats } from '../../constants/narrativeStats.js';
    import { nationalStats } from '../../constants/nationalStats.js';
    import Totals from "./Totals";
    import NumberUtilities from "../../utilities/NumberUtilities";
    import NarrativeDisclaimer from "../narrative/NarrativeDisclaimer";
    export default {
        components: {
            NarrativeDisclaimer,
            Totals
        },
        mixins: [
            NumberUtilities
        ],
        data(){
            return {
                narrativeStats,
                nationalStats,
                checkbox: true,
            }
        },
        computed: {
            narrativeCounts(){
                return Object.entries(this.nationalStats.narratives).map(narrative => ({
                    name: this.narrativeStats[narrative[0]].display,
                    narrative: narrative[0],
                    color: narrative[0],
                    count: narrative[1]
                }));
            },
            raceCounts(){
                return Object.values(this.nationalStats.races).filter(race => race.name != 'Total' && race.name != "U.S. Senator Wins" && race.name != "U.S. Representative Wins" && race.count > 0).map(race => ({
                    ...race,
                    color: 'primary'
                }));
            },
            totalCounts() {
                return this.narrativeStats.technology.stats

            }
        }
    }
</script>
<style lang="scss">
    .national-races{
        //margin-bottom: 50px;
        
        .v-toolbar__title {
            overflow: inherit;
        }
        .v-card__title{
            white-space: nowrap;
            font-size: 1rem!important;
        }

        p{
            margin: 0;
        }
        &__subtitle{
            font-size: 14px;
        }
        &__title{
            font-size: 20px;
            overflow-wrap: break-word;
            white-space: normal;
        }
    }
</style>